/*    
<summary>
  This functional component is used for Create new Account.
  Developer:Aashish Singh, Created Date:07-Feb-2024
</summary>
<returns>Returns JSX</returns>
*/

import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useHistory, withRouter } from "react-router-dom";
import { formatMessage } from "../../translations/format-message";
import { observer } from "mobx-react";
import { useStore } from "../../contexts/StoreProvider";
import Footer from "../../shared-components/Footer/Footer";
import UserRegistrationForm from "../user/forms/user-registration-form";
import FormLoader from "../../shared-components/FormLoader/FormLoader";
import { initialState } from "../../core/initial-state/add-trial-tenant-state";
import RoutesConstants from "../../shared-components/Routes/routes.constants";

const CreateAccount = () => {
  const { tenantStore } = useStore();
  const {
    AddTrialTenant,
    addTrialTenantState,
    resetAddTrialTenantState,
    resetGenerateOrgIdState, 
    generateOrgIdState,
  } = tenantStore;
  const history = useHistory();

  const [selectedEmail, setSelectedEmail] = useState<string>("")
  
  const submitTenant = (values: any) => {
    setSelectedEmail(values.Email);
    AddTrialTenant(values);
  };

  /**
   * The function we pass to the useEffect Hook runs when the component is mounted and when it is re-rendered while
   * dependency "addUpdateDevicestate.success" of the useEffect changed.
   */
  useEffect(() => {
    if (addTrialTenantState.success) {
      localStorage.setItem("mzl_selected_resend_email", selectedEmail);
      history.push({
        pathname: RoutesConstants.ResendMail,
        state: {
          email: selectedEmail
        },
      });
    }
    setSelectedEmail("");
    resetAddTrialTenantState();
    resetGenerateOrgIdState();
  }, [addTrialTenantState.success]);

  // useEffect(() => {
  //   localStorage.removeItem("mzl_selected_resend_email");
  // }, []);
  
  useEffect(() => {
    if (addTrialTenantState.error) {
      toast.success(formatMessage(addTrialTenantState.error));
      resetAddTrialTenantState();
    }
  }, [addTrialTenantState.error]);

  return (
    <>
      {(addTrialTenantState.inProgress || generateOrgIdState.inProgress) && (
        <FormLoader loading={(addTrialTenantState.inProgress || generateOrgIdState.inProgress)} />
      )}
      <div className="bg-img1 text-start background">
        <UserRegistrationForm
          initialValues={initialState}
          actionSuccess={addTrialTenantState.success}
          submitHandler={submitTenant}
        />
      </div>
      <Footer />
    </>
  );
};

export default withRouter(observer(CreateAccount));
